'use es6';

import PropTypes from 'prop-types';
import { stringify } from 'hub-http/helpers/params';
import PortalIdParser from 'PortalIdParser';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import { LockBadge } from 'foundations-components/transitional/components/LockBadge';
import { useUpgradeModal } from 'ui-addon-upgrades/ums/useUpgradeModal';
import { Link } from 'foundations-components/transitional/components/Link';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { Text } from 'foundations-components/components/Text';
import { IconHolder } from 'foundations-components/transitional/components/IconHolder';
import { UpgradeIcon } from 'foundations-assets';
import AttributionUsageTracker, { ACTIONS, EVENTS } from '../../usageTracker.js';
import { PQL_KEYS } from './constants.js';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function AttributionBuilderLink({
  paddingBlockStart,
  hasRevenueAttributionAccess,
  hasRevenueAttributionLimitedAccess,
  screen,
  urlQueryParams,
  withUpdateDateRangeUpgrade = false,
  isInlineUpgrade = false,
  children
}) {
  const {
    openUpgradeModal
  } = useUpgradeModal(withUpdateDateRangeUpgrade ? PQL_KEYS.DATE_RANGE : PQL_KEYS.OPEN_BUILDER);
  const attributionLink = `/attribution-builder/${PortalIdParser.get()}/revenue?${stringify(urlQueryParams)}`;
  const handleBuilderClick = event => {
    event.preventDefault();
    if (!hasRevenueAttributionAccess || hasRevenueAttributionLimitedAccess) {
      openUpgradeModal();
      return;
    }
    AttributionUsageTracker.track(EVENTS.REVENUE_ATTRIBUTION_CARD, {
      action: ACTIONS.OPENED_BUILDER,
      screen
    });
    window.open(attributionLink);
  };
  if (isInlineUpgrade) {
    return /*#__PURE__*/_jsxs(Link, {
      "data-test-id": "attribution-builder-link",
      marginInlineStart: '100',
      href: attributionLink,
      onClick: handleBuilderClick,
      children: [children !== null && children !== void 0 ? children : /*#__PURE__*/_jsx(FormattedMessage, {
        message: "components.revenueAttributionCard.limitedAccess.inlineUpgradeText"
      }), /*#__PURE__*/_jsx(IconHolder, {
        icon: UpgradeIcon,
        size: "200",
        marginInlineStart: "50",
        padding: "0",
        color: "icon-secondary-default"
      })]
    });
  }
  if (hasRevenueAttributionLimitedAccess) {
    return /*#__PURE__*/_jsxs(TFlex, {
      "data-test-id": "attribution-builder-link--limited-access",
      align: "center",
      justify: "center",
      children: [/*#__PURE__*/_jsx(Text, {
        marginInlineStart: "100",
        children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
          message: `components.revenueAttributionCard.limitedAccess.${withUpdateDateRangeUpgrade ? 'iconLinkText_jsx' : 'moreLinkText_jsx'}`,
          elements: {
            Link
          },
          options: {
            external: true,
            href: attributionLink,
            onClick: handleBuilderClick
          }
        })
      }), /*#__PURE__*/_jsx(LockBadge, {})]
    });
  }
  return /*#__PURE__*/_jsxs(TFlex, {
    align: "center",
    justify: "center",
    children: [/*#__PURE__*/_jsx(Link, {
      "data-test-id": "attribution-builder-link",
      paddingBlockStart: paddingBlockStart,
      external: hasRevenueAttributionAccess,
      href: attributionLink,
      onClick: handleBuilderClick,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "components.revenueAttributionCard.linkTextV2"
      })
    }), !hasRevenueAttributionAccess && /*#__PURE__*/_jsx(LockBadge, {
      "data-test-id": "attribution-builder-link--lock-badge"
    })]
  });
}
AttributionBuilderLink.propTypes = {
  screen: PropTypes.string.isRequired,
  urlQueryParams: PropTypes.object,
  hasRevenueAttributionAccess: PropTypes.bool.isRequired,
  hasRevenueAttributionLimitedAccess: PropTypes.bool.isRequired,
  withUpdateDateRangeUpgrade: PropTypes.bool,
  isInlineUpgrade: PropTypes.bool,
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.node])
};